import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';

const CommunityClubPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        pt: 10,
        pb: 8,
        background: 'transparent',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Users size={32} color="#2563EB" />
            <Typography
              component="h1"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                fontWeight: 700,
                color: '#1E293B',
              }}
            >
              Community Club
            </Typography>
          </Box>
          <Typography sx={{ color: '#64748B', lineHeight: 1.7 }}>
            Coming soon. Stay tuned to join our network of builders, thinkers, and leaders.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CommunityClubPage;
